export interface DeleteAddressState {
  isLoading: boolean;
  error: any;
}

export const deleteAddressInitialState: DeleteAddressState = {
  isLoading: false,
  error: null
};
